<!-- The teal top edge repeats the downloaded report's masthead rule. -->
<div
  data-testid="file-card"
  class="bg-surface border-default border-t-accent-main flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-t-2 px-3 py-2.5">
  <span
    class="bg-accent-interactive text-accent-main flex size-8 shrink-0 items-center justify-center rounded-sm text-base">
    <i [class]="icon()"></i>
  </span>
  <div class="min-w-40 flex-1">
    <div
      class="text-text-primary truncate text-[13px] leading-snug font-semibold"
      [title]="file().title">
      {{ file().title }}
    </div>
    @if (available()) {
      <div class="text-text-tertiary text-2xs truncate font-mono" [title]="meta()">
        {{ meta() }}
      </div>
    } @else {
      <div class="text-text-tertiary text-xs leading-snug">
        {{ 'assistant.files.unavailable' | translate }}
      </div>
    }
  </div>
  <div class="ml-auto flex shrink-0 items-center gap-1.5">
    <button
      type="button"
      data-testid="file-preview"
      class="btn btn-cancel btn-sm"
      [disabled]="!available()"
      (click)="assistant.openPreview(file())">
      <i [class]="ICONS.eye"></i>
      {{ 'assistant.files.preview' | translate }}
    </button>
    <button
      type="button"
      data-testid="file-download"
      class="btn btn-primary btn-sm"
      [disabled]="!available()"
      (click)="reports.download(file())">
      <i [class]="ICONS.download"></i>
      {{ 'assistant.files.download' | translate }}
    </button>
  </div>
</div>
